import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const PuzzleModule = {
  namespaced: true,

  state: {
    authors: [],
    puzzle: {},
    puzzles: []
  },

  getters: {
  },

  actions: {
    async getPuzzle ({ commit, state }, puzzleId) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/puzzles/' + puzzleId
      ).then((resp) => {
        commit('storePuzzle', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getPuzzles ({ commit, state }, puzzleIds) {
      commit('setLoading', true, { root: true })
      commit('resetPuzzles')

      let count = 0
      puzzleIds.forEach((id) => {
        this.dispatch(
          `PuzzleModule/getPuzzle`, id
        ).then(() => {
        }).finally(() => {
          count += 1
          if (count === puzzleIds.length) {
            commit('setLoading', false, { root: true })
          }
        })
      })
    },

    async regenerateFiles ({ commit, state }, puzzleId) {
      commit('setLoading', true, { root: true })

      await PaApi().put(
        '/admin/puzzles/' + puzzleId + '/regenerate_files'
      ).then((resp) => {
        commit('storePuzzle', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async setAttachments ({ commit, state }, attachments) {
      commit('storePuzzleAttachments', attachments)
    }
  },

  mutations: {
    resetPuzzles (state) {
      state.puzzles = []
    },

    storePuzzle (state, payload) {
      let puzzle = processSuccess(payload, baseOpts)
      puzzle.attachments = puzzle.attachments.map(item => item.attributes)

      state.puzzle = puzzle
    },

    storePuzzleAttachments (state, payload) {
      state.puzzle.attachments = processSuccess(payload, baseOpts)
    },

    storePuzzles (state, payload) {
      state.puzzles = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/PuzzleModule.js